import React, { Component } from 'react'

import classNames from './Modal.css'
import Icon from '../Icon'
import { IS_IOS } from '../../constants'

export default class Modal extends Component {
  componentDidMount () {
    document.body.style.overflow = 'hidden'
    if (IS_IOS && window.scrollY === 0) {
      document.body.style.position = 'fixed'
    }
  }
  componentWillUnmount () {
    document.body.style.overflow = ''
    document.body.style.position = ''
  }
  render () {
    const { title, onClose, children, style } = this.props
    return (
      <div className={classNames.modal} style={style}>
        {title &&
          <header className={classNames.header}>
            {onClose &&
              <button className={classNames.close} onClick={onClose}>
                <Icon icon='close' />
              </button>
            }
            {title}
          </header>
        }
        {children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/Modal.js